import { render, staticRenderFns } from "./tradingInformation.vue?vue&type=template&id=4e0f5f50&scoped=true"
import script from "./tradingInformation.vue?vue&type=script&lang=js"
export * from "./tradingInformation.vue?vue&type=script&lang=js"
import style0 from "./tradingInformation.vue?vue&type=style&index=0&id=4e0f5f50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0f5f50",
  null
  
)

export default component.exports